module.exports = __webpack_public_path__ + "static/img/footer_ewm.765cee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/footer_ewm.png
// module id = TLz5
// module chunks = 44